<div class="upload-icon-popup">
  <nz-row [nzGutter]="10">
    <nz-col [nzSpan]="24">
      <div class="section-label">Select Icon:</div>
      <div class="selectIconContainer">
        <div class="iconMainContainer">
          <ng-container *ngFor="let item of processIcons">
            <div [ngClass]="getIconContainerClass(item)" 
                 class="iconContainer" 
                 (click)="selectedProcessIcon(item)">
              <img [src]="item.image" style="width: 16px;height: 16px;">
            </div>
          </ng-container>
        </div>
      </div>
    </nz-col>
    <!-- OR Divider -->
    <nz-col [nzSpan]="24" class="mt-10">
      <div class="or-divider">
        <span class="or-line"></span>
        <span style="margin-left:180px">OR</span>
        <span class="or-line"></span>
      </div>
    </nz-col>

    <!-- Upload Section -->
    <nz-col [nzSpan]="24" class="mt-10">
      <div class="section-label">Upload Icon:</div>
      <div class="upload-container">
        <ng-container *ngIf="!selectedImgDataUrl; else previewTpl">
          <nz-upload
            nzHeight="200px"
            nzType="drag"
            [nzMultiple]="false"
            [nzAccept]="'.svg'"
            [nzBeforeUpload]="beforeIconUpload"
            [nzShowUploadList]="false"
          >
            <ng-container>
              <p class="ant-upload-drag-icon">
                <i nz-icon nzType="upload" nzTheme="outline" style="font-size: 24px; color: #1890ff;"></i>
              </p>
              <div class="f-13 fw-400 lightBlackColor">
                Drag and drop a file here
              </div>
              <div>or</div>
              <div class="blueColor cPointer">Browse File</div>
              <p class="ant-upload-hint">Support .svg files only (25x25, 100kb max)</p>
            </ng-container>
          </nz-upload>
        </ng-container>

        <ng-template #previewTpl>
          <div class="upload-preview-placeholder">
            <div class="uploaded-icon">
              <img [src]="selectedImgDataUrl" style="width: 40px; height: 40px;">
              <button class="remove-icon-btn" type="button" aria-label="Remove icon" (click)="removeUploadedIcon()">
                <i nz-icon nzType="close" nzTheme="outline"></i>
              </button>
            </div>
            <div class="uploaded-icon-info">
              <span class="file-name">{{ iconFileName || selectedImgKey }}</span>
            </div>
          </div>
        </ng-template>

        <!-- File Error Display -->
        <div *ngIf="fileError" class="file-error">
          {{ fileError }}
        </div>
      </div>
    </nz-col>
  </nz-row>

  <!-- Action Buttons -->
  <nz-row class="mt-35" style="justify-content: center">
    <div class="text-center">
      <button
        nz-button
        [disabled]="isIconUploading"
        [nzLoading]="isIconUploading"
        class="save"
        nzType="primary"
        class="f-10 fw-700"
        style="padding: 8px 24px;color: white!important;"
        (click)="uploadIcon()"
      >
        UPLOAD
      </button>
    </div>
    <div class="text-center f-10 fw-700 lh-18 blueColor">
      <button
        [disabled]="isIconUploading"
        nz-button
        nzType="default"
        class="buttonDefault f-10 fw-700 cancel"
        style="height: 37px; border-radius: 5px; margin-left: 20px;color: #1D66FF!important;
        border: 1px solid #1D66FF!important;"
        (click)="cancel()"
      >
        CANCEL
      </button>
    </div>
  </nz-row>
</div>
